import { eventTracking } from '@/service/task.js'
import mammoth from 'mammoth' // 引入 mammoth.js 解析 .docx 文件
import { ElMessage } from 'element-plus'

const copyToClipboard = async (content, type = 'text/markdown') => {
  try {
    if (type === 'text/markdown') {
      // 直接复制 Markdown 文本
      await navigator.clipboard.writeText(content)
    } else {
      // 对于其他类型，保持原有的逻辑
      const blob = new Blob([content], { type })
      const clipboardItem = new ClipboardItem({ [type]: blob })
      await navigator.clipboard.write([clipboardItem])
    }
    alert('内容已复制到剪贴板')
  } catch (error) {
    console.error('复制失败:', error)
    alert('复制失败')
  }
}

const eventTrackingFunc = (params) => {
  let newParams = {
    os: getOSname(),
    client_time: Date.now(),
    uuid: localStorage.getItem('uuid'),
    client_type: checkBrower(),
    ...params
  }
  eventTracking(newParams)
}

const getOSname = () => {
  var userAgent = navigator.userAgent.toLowerCase()
  var name = 'Unknown'
  var version = 'Unknown'
  if (userAgent.indexOf('win') > -1) {
    name = 'Windows'
    if (userAgent.indexOf('windows nt 5.0') > -1) {
      version = 'Windows 2000'
    } else if (
      userAgent.indexOf('windows nt 5.1') > -1 ||
      userAgent.indexOf('windows nt 5.2') > -1
    ) {
      version = 'Windows XP'
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      version = 'Windows Vista'
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      version = 'Windows 7'
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      version = 'Windows 8'
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      version = 'Windows 8.1'
    } else if (
      userAgent.indexOf('windows nt 6.2') > -1 ||
      userAgent.indexOf('windows nt 10.0') > -1
    ) {
      version = 'Windows 10'
    } else {
      version = 'Unknown'
    }
  } else if (userAgent.indexOf('iphone') > -1) {
    name = 'iPhone'
  } else if (userAgent.indexOf('mac') > -1) {
    name = 'Mac'
  } else if (
    userAgent.indexOf('x11') > -1 ||
    userAgent.indexOf('unix') > -1 ||
    userAgent.indexOf('sunname') > -1 ||
    userAgent.indexOf('bsd') > -1
  ) {
    name = 'Unix'
  } else if (userAgent.indexOf('linux') > -1) {
    if (userAgent.indexOf('android') > -1) {
      name = 'Android'
    } else {
      name = 'Linux'
    }
  } else {
    name = 'Unknown'
  }
  return name
}

const checkBrower = () => {
  var sBrowser = null
  var userAgent = window.navigator.userAgent
  // The order matters here, and this may report false positives for unlisted browsers.
  if (userAgent.indexOf('Firefox') > -1) {
    sBrowser = 'Mozilla Firefox'
    // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
  } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    sBrowser = 'Opera'
    // 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106'
  } else if (userAgent.indexOf('Trident') > -1) {
    sBrowser = 'Microsoft Internet Explorer'
    // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
  } else if (userAgent.indexOf('Edge') > -1) {
    sBrowser = 'Microsoft Edge'
    // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
  } else if (userAgent.indexOf('Chrome') > -1) {
    sBrowser = 'Google Chrome or Chromium'
    // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
  } else if (userAgent.indexOf('Safari') > -1) {
    sBrowser = 'Apple Safari'
    // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
  } else {
    sBrowser = 'unknown'
  }
  return sBrowser
}

// 获取图片尺寸
function getImageSize(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = function () {
      resolve({ width: this.width, height: this.height })
    }
    img.onerror = function () {
      reject(new Error('Failed to load image'))
    }
    img.src = url
  })
}

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    let fileResult = ''
    reader.readAsDataURL(file.raw)
    reader.onload = () => (fileResult = reader.result)
    reader.onerror = (error) => reject(error)
    reader.onloadend = () => resolve(fileResult)
  })
}

function base64ToFile(base64Data, fileName) {
  // 从 base64 字符串中提取 MIME 类型
  const mime = base64Data.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)[1]
  // 移除 base64 URL 的前缀以获取实际的 base64 数据
  const base64 = base64Data.split(',')[1]
  const byteCharacters = atob(base64)
  const byteNumbers = new Array(byteCharacters.length)

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: mime })

  return new File([blob], fileName, { type: mime })
}

// post下载文件
const fileDownload = (res, filename) => {
  let blob = new Blob([res.data], { type: 'application/zip' }) // 将返回的数据通过Blob的构造方法，创建Blob对象
  if ('msSaveOrOpenBlob' in navigator) {
    window.navigator.msSaveOrOpenBlob(blob, filename) // 针对浏览器
  } else {
    const elink = document.createElement('a') // 创建a标签
    elink.download = filename
    elink.style.display = 'none'
    // 创建一个指向blob的url，这里就是点击可以下载文件的根结
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) //移除链接
    document.body.removeChild(elink) //移除a标签
  }
}

/**
 * 将时间格式化为 YYYYMMDDHHmmss 格式
 * @param {Date|string} timeStr - 时间字符串或Date对象
 * @returns {string} - 格式化后的时间字符串，格式为 YYYYMMDDHHmmss
 */
export const formatToYYYYMMDDHHmmss = (timeStr) => {
  if (!timeStr) return '未命名'

  try {
    // 创建一个新的 Date 对象
    const date = new Date(timeStr)

    // 检查是否是下午时间（0-11点），如果是则加12小时
    const hours = date.getHours()
    if (hours >= 0 && hours < 12) {
      date.setHours(hours + 12)
    }

    // 获取年月日时分秒
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const finalHours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    // 拼接 YYYYMMDDHHmmss 格式
    return `${year}${month}${day}${finalHours}${minutes}${seconds}`
  } catch (error) {
    console.error('时间格式化错误:', error)
    return '未命名'
  }
}

// 随机颜色
const getRandomColorCombination = () => {
  const colors = [
    'rgba(7, 7, 7, 1)',
    'rgba(255, 255, 255, 1)',
    'rgba(255, 242, 0, 1)',
    'rgba(231, 8, 8, 1)',
    'rgba(0,0, 0, 0)'
  ]
  const colorCombinations = [
    { fill: colors[0], background_color: colors[2], stroke_fill: colors[4] },
    { fill: colors[1], background_color: colors[4], stroke_fill: colors[0] },
    { fill: colors[2], background_color: colors[4], stroke_fill: colors[0] },
    { fill: colors[0], background_color: colors[4], stroke_fill: colors[1] },
    { fill: colors[3], background_color: colors[4], stroke_fill: colors[1] },
    { fill: colors[1], background_color: colors[3], stroke_fill: colors[4] }
  ]
  const randomIndex = Math.floor(Math.random() * colorCombinations.length)
  return colorCombinations[randomIndex]
}

const rgbaToArray = (rgbaStr) => {
  // 点击了clear 设置为[255, 255, 255, 0]
  if (!rgbaStr) return [255, 255, 255, 0]
  // 使用正则表达式匹配RGBA值
  const match = rgbaStr.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+),\s*(\d+(?:\.\d+)?)\)$/)
  if (match) {
    // 将匹配的字符串值转换为数字，并保留透明度的浮点数形式
    return [parseInt(match[1]), parseInt(match[2]), parseInt(match[3]), parseFloat(match[4])]
  }
  // 如果没有匹配到，返回null或抛出错误
  return null
}

const arrayToRgba = (rgbaArray) => {
  if (!rgbaArray || rgbaArray.length !== 4) {
    throw new Error('Invalid RGBA array. It must contain exactly 4 elements.')
  }
  const [r, g, b, a] = rgbaArray
  // 确保每个值都在有效范围内
  if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255 || a < 0 || a > 1) {
    throw new Error(
      'Invalid RGBA values. R, G, B must be between 0 and 255, and A must be between 0 and 1.'
    )
  }
  // 返回rgba字符串
  return `rgba(${r}, ${g}, ${b}, ${a})`
}

// 获取srt的第一句话
const getFirstSentenceFromSrt = (srtText) => {
  // 按块分割SRT文本，每个块以两个换行符分隔
  const blocks = srtText.split(/\n\n+/)

  // 检查是否有块，并且取第一块
  if (blocks.length > 0) {
    const firstBlock = blocks[0]

    // 按行分割第一块
    const lines = firstBlock.split('\n')

    // 找到第一个非时间戳的行，即第一句
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim()
      // 检查行是否不为空，并且不是时间戳
      if (
        line &&
        !line.match(/^\d+$/) &&
        !line.match(/^\d{2}:\d{2}:\d{2},\d{3} --> \d{2}:\d{2}:\d{2},\d{3}$/)
      ) {
        return line
      }
    }
  }
  return '' // 如果没有找到任何文本行，返回空字符串
}

// 读取文件为 ArrayBuffer
const readFileAsArrayBuffer = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(new Error('文件读取失败'))
    reader.readAsArrayBuffer(file)
  })
}

// 解析 .docx 文件
const parseDocxFile = async (arrayBuffer) => {
  try {
    const result = await mammoth.convertToHtml({ arrayBuffer })
    return result.value
  } catch (error) {
    ElMessage.error('文件解析失败，请检查文件格式')
  }
}

// 读取文件为文本（用于 .srt）
const readFileAsText = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(new Error('文件读取失败'))
    reader.readAsText(file, 'UTF-8') // 指定 UTF-8 编码
  })
}

// 解析 SRT 文件
const parseSRTContent = (srtText) => {
  // 分割字幕块（以空行分隔）
  const blocks = srtText.split(/\n\s*\n/)
  let result = []

  blocks.forEach((block) => {
    // 按行分割并过滤空行
    const lines = block.split('\n').filter((line) => line.trim() !== '')

    // 有效字幕块至少包含序号、时间轴、文本
    if (lines.length >= 3) {
      // 提取文本行（跳过序号和时间轴）
      const textLines = lines.slice(2)
      result.push(...textLines)
    }
  })

  return result.join('\n') // 合并为纯文本
}

// 秒转标准格式
const formatSecondsToTime = (t) => {
  const seconds = Math.floor(parseFloat(t))
  const hours = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMins = mins.toString().padStart(2, '0')
  const formattedSecs = secs.toString().padStart(2, '0')

  // 如果小时为 0，则只返回 MM:SS
  if (hours === 0) {
    return `${formattedMins}:${formattedSecs}`
  }
  return `${formattedHours}:${formattedMins}:${formattedSecs}`
}

const formatNumberWithCommas = (num, decimalPlaces = 0) => {
  // 处理非数字输入
  if (num === null || num === undefined || num === '') return '0'

  // 转换为数字
  const number = typeof num === 'string' ? parseFloat(num.replace(/,/g, '')) : num

  // 检查是否为有效数字
  if (isNaN(number)) return '0'

  // 格式化数字
  return number.toLocaleString('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  })
}

export {
  copyToClipboard,
  eventTrackingFunc,
  getOSname,
  checkBrower,
  getImageSize,
  toBase64,
  base64ToFile,
  fileDownload,
  getRandomColorCombination,
  rgbaToArray,
  arrayToRgba,
  getFirstSentenceFromSrt,
  readFileAsArrayBuffer,
  parseDocxFile,
  readFileAsText,
  parseSRTContent,
  formatSecondsToTime,
  formatNumberWithCommas
}
